import { takeLatest, select, call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";

const saveRegisterFromApi = (data, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/register/", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Authorization": token
			},
			data
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
	});
};

function* saveRegister(payload) {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);
		
		yield call(saveRegisterFromApi, payload.data.register, token);
		
		yield put({ type: "SET_REGISTER_SUCCESS", payload:{ success: true, type: "save" }});

	} catch (error) {
		
		yield put({ type: "SET_REGISTER_ERROR", payload:{ error: true, data: error }});

	}
}

// //Generator function
export function* getRegisterWatcher() {
	yield takeLatest("SAVE_REGISTER", saveRegister);
}